import { IdGenerator } from '../utils';

export class ErrorViewModel {
  public readonly id: string;
  public readonly message: string;
  public readonly timestamp ?: number;

  constructor(  public readonly errCode: string,
                public readonly errMsg: string) {

                    this.id = IdGenerator.generateId().toString();
                    this.timestamp = Date.now();

                    // TODO add internationalized message
                    this.message = errMsg ? errMsg : 'We appear to be having difficulties. Please check back shortly.';
  }
}
